// Client instrumentation (Next's `instrumentation-client` convention): router
// transition hooks that must run BEFORE a navigation is dispatched.
import { beginRouterNavigation } from '@auctogon/admin-frontend/hooks/list-url-navigation';

/**
 * Next calls this synchronously before every app-router navigation is
 * dispatched. BUG-1798: settle list URL writes first, so a debounced term
 * write cannot land mid-navigation and cancel it.
 *
 * @param url - The destination.
 * @param navigationType - `'push'`, `'replace'` or `'traverse'`.
 * @returns Nothing.
 *
 * @sideEffect May write unsettled list terms to the URL via `history.replaceState`.
 */
export function onRouterTransitionStart(url: string, navigationType: string): void {
    beginRouterNavigation(navigationType, url);
}
